import { EmailCheckOutlineIcon } from './EmailCheckOutlineIcon';

/**
 * author: Andrew Nenakhov
 * id 465CA7E2-56E8-4AC8-9A0D-CFF225C3948A
 * name email-check-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-check-outline.svg
 * tags
 */
export const EmailTickOutlineIcon = EmailCheckOutlineIcon;
export default EmailTickOutlineIcon